import type { CreateDrawerStep } from '../dashboards/primitives';

import FormErrorBanner from './FormErrorBanner';
import ClientStep from './steps/ClientStep';
import CommercialsStep from './steps/CommercialsStep';
import WhenWhereStep from './steps/WhenWhereStep';
import type { PrivateEventForm } from './usePrivateEventForm';

/**
 * The three steps of the create-private-event drawer (BON-518).
 *
 * There is deliberately NO visibility control in any of them, and there must
 * never be one. A private event is never publicly bookable because it carries a
 * detail row, not because someone ticked a box — a toggle would imply the
 * setting can go the other way, and it cannot.
 */
export function buildPrivateEventSteps(form: PrivateEventForm): CreateDrawerStep[] {
  return [
    {
      id: 'when-where',
      label: 'When & where',
      hint: 'venue, date, type',
      content: (
        <>
          <WhenWhereStep form={form} />
          <FormErrorBanner form={form} />
        </>
      ),
    },
    {
      id: 'client',
      label: 'Client',
      hint: 'who it is for',
      content: (
        <>
          <ClientStep form={form} />
          <FormErrorBanner form={form} />
        </>
      ),
    },
    {
      id: 'commercials',
      label: 'Deal & add-ons',
      hint: 'value, extras',
      content: (
        <>
          <CommercialsStep form={form} />
          <FormErrorBanner form={form} />
        </>
      ),
    },
  ];
}
